import { ApiParameter, get, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export async function customQuoteStatusUpdate(orderNumber: string) {
    try {   
        const result = await post<string, any>(`api/v1/quotestatus/UpdateQuote/${orderNumber}`, orderNumber);
     
        return {
            successful: true,
            result,
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error updating quote status:", error);
        throw error;
    }
}

export async function removeQuoteLine(quotelineId: string,quoteId: string) {
    try {   
        const result = await get<any>(`api/v1/quoteremoveline?LineId=${quotelineId}&Id=${quoteId}`);
     
        return {
            successful: true,
            result,
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error updating quote status:", error);
        throw error;
    }
}


export interface QuoteLineNoteApiParameter extends ApiParameter {
    quoteId: string;
    quoteLineId: string;
    Note: string;
}

export async function updateQuoteLineNote(
    parameter: QuoteLineNoteApiParameter,
): Promise<any> {
    try {
        const result = await post<QuoteLineNoteApiParameter, any>(
            `api/v1/updatequoteline/note`,
            parameter,
        );

        return {
            successful: true,
            result,
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error updating the note line:", error);
        throw error;
    }
}